import { useState, useEffect, useCallback } from "react";

import { useIsMobile } from "./useIsMobile";

export const useIsScrollTopBottom = () => {
  const isMobile = useIsMobile();
  const [isTop, setIsTop] = useState(true);
  const [isBottom, setIsBottom] = useState(false);

  const onScrollHandler = useCallback((el: HTMLElement | null) => {
    if (!el) {
      return;
    }
    const { scrollTop, scrollHeight, clientHeight } = el;

    setIsTop(scrollTop === 0);
    setIsBottom(clientHeight + scrollTop >= scrollHeight);
  }, []);

  useEffect(() => {
    if (isMobile) {
      const scrollableElement = document.documentElement;
      onScrollHandler(scrollableElement);
    }
  }, [isMobile, onScrollHandler]);

  return { isTop, isBottom, onScrollHandler };
};
